import { Fragment } from 'react';
import { Tag, Space, Image, Carousel, List, Card, Badge, Typography } from 'antd';
import { formatDay } from '../../../util/utils';
import { CalendarOutlined } from '@ant-design/icons';

import './LottoInfo.css';

const { Title, Paragraph, Text } = Typography;

const bundles = [
    { tickets: 1, popular: false },
    { tickets: 2, popular: false },
    { tickets: 3, popular: false },
    { tickets: 5, popular: true },
    { tickets: 10, popular: false },
    { tickets: 20, popular: false },
    { tickets: 100, popular: false },
];

export default function LottoInfo(props) {
    const { data } = props;
    return (
        <Fragment>
            <div className="boletos-header-section">
                <Tag color="red" className="boletos-event-tag">SORTEO #{data?.lottoNumber}</Tag>
                <Title level={1} className="boletos-main-title">
                    {data?.title}
                    <br />
                    <span className="boletos-highlight">{data?.subtitle}</span>
                </Title>
                <Space className="boletos-date-badge">
                    <CalendarOutlined />
                    <Text style={{ textTransform: 'uppercase' }} strong>{formatDay(data?.lottoDate)}</Text>
                </Space>
            </div>

            <div className='boletos-images-carousel'>
                <Carousel autoplay>
                    {data?.photos?.map((photo, index) => (
                        <div key={index}>
                            <Image
                                preview={false}
                                src={photo.photoLink}
                                alt={`Sorteo ${index + 1}`}
                                style={{ width: '100%', objectFit: 'cover', borderRadius: '20px' }}
                            />
                        </div>
                    ))}
                </Carousel>
            </div>

            <div>
                <List
                    grid={{ gutter: 16, xxl: 7, xl: 7, lg: 7, md: 7, sm: 3, xs: 3 }}
                    dataSource={bundles}
                    renderItem={(item) => (
                        <List.Item>
                            <Badge.Ribbon
                                text="Más vendido"
                                color="gold"
                                style={{ display: item.popular ? 'block' : 'none' }}
                            >
                                <Card style={{ textAlign: 'center' }}>
                                    <Text style={{ fontSize: '14px', color: '#666' }} strong>{item.tickets} {item.tickets === 1 ? 'boleto' : 'boletos'}</Text>
                                    <br />
                                    <Text style={{ fontSize: '16px' }} strong>${data?.ticketPrice * item.tickets}</Text>
                                </Card>
                            </Badge.Ribbon>
                        </List.Item>
                    )}
                />
            </div>

            <div className='premios-section'>
                <Card className="image-card">
                    <div>
                        <Title level={3}>Con tu boleto pagado participas por:</Title>
                        <Text style={{ fontSize: '26px', color: '#a63429', textTransform: 'uppercase' }} strong>
                            {data?.subtitle}{data?.awards?.length > 0 || data?.bonuses?.length > 0 ? " + BONOS" : ""}
                        </Text>
                        <br /><br />
                        {data?.awards?.length > 0 && (
                            <>
                                <Title level={4} style={{ marginTop: '5px' }}>
                                    Con los siguientes premios por lugar:
                                </Title>
                                {data?.awards?.map((award) => (
                                    <Fragment key={award.place}>
                                        <Text style={{ fontSize: '16px', color: '#a63429' }} strong>
                                            {award.place}
                                        </Text>
                                        <Text style={{ fontSize: '16px' }} strong>
                                            {" - "}{award.award}
                                        </Text>
                                        <br />
                                    </Fragment>
                                ))}
                                <br />
                            </>
                        )}
                    </div>
                    {data?.bonuses?.length > 0 && (
                        <>
                            {["Super Bono", "Extra Bono"].map((category, index) => (
                                <Fragment key={index}>
                                    <Title level={4}>
                                        {category === "Super Bono" ? "SÚPER BONOS" : "BONOS EXTRAS"}
                                    </Title>
                                    {data?.bonuses
                                        ?.filter((bonus) => bonus.category === category)
                                        ?.map((bonus, indey) => (
                                            <div key={indey}>
                                                <Text style={{ fontSize: "16px", color: "#a63429" }} strong>
                                                    {bonus.bonus}
                                                </Text>
                                                <br />
                                                <Text style={{ fontSize: "16px" }} strong>
                                                    {bonus.bonusCondition}
                                                </Text>
                                                <br />
                                                <br />
                                            </div>
                                        ))}
                                </Fragment>
                            ))}
                        </>
                    )}
                    <br />
                    <Paragraph type="secondary" style={{ fontSize: '15px' }}>
                        * Boletos Acumulables (Válidos únicamente hasta la fecha del sorteo, con pago confirmado en un plazo máximo de 15 minutos, sin excepciones y registrados bajo los mismos datos.)
                    </Paragraph>
                    <Paragraph type="secondary" style={{ fontSize: '15px' }}>
                        * Con tu boleto pagado participas automáticamente en el sorteo.
                    </Paragraph>
                </Card>
            </div>
        </Fragment>
    );
}